<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>指标组</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          style="width:300px"
          placeholder="请输入指标名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" class="m-l-10" @click="doNew">
          新增指标
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields">
            <template slot="scoreCalcRuleIds">
              <el-table-column
                prop="scoreCalcRuleIds"
                width="150px"
                :show-overflow-tooltip="false"
                label="指标"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" placement="top">
                    <!-- // {{}}会将数据解释为普通文本，而非 HTML 代码。 -->
                    <div v-html="getTooltipContent(scope.row)" slot="content"></div>
                    <div class="oneLine">
                      <span v-for="item in scope.row.scoreCalcRuleIds" :key="item">
                        {{ options.rules.filter(key => key._id == item)[0].name }}权重为：
                        {{ scope.row.scrWeightMap[item] }}
                      </span>
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
            </template>
          </c-table>

          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>

                  <el-dropdown-item
                    v-if="osg.has('ScoreCalcRule,operation') && scope.row.state == -1"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('ScoreCalcRule,operation') && scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('ScoreCalcRule,operation')"
                    @click.native="doRemove(scope.row._id)"
                  >
                    删除
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('ScoreCalcRule,operation')"
                    @click.native="viewRanking(scope.row)"
                  >
                    查看排行
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="指标组" :visible.sync="openDetail" width="700px">
      <c-form
        :area="area"
        :options="options"
        :formData="formData"
        :fields="extFields"
        ref="scoreForm"
        labelWidth="100px"
      >
        <template slot="scoreCalcRuleIds">
          <el-select
            v-model="formData.scoreCalcRuleIds"
            filterable
            multiple
            clearable
            style="margin-bottom:18px;"
            :no-data-text="!formData.region ? '请先选择行政区划' : '没有适用当前服务资源类型的指标'"
            @change="indexsChange"
          >
            <template v-for="(item, i) in options.rules">
              <el-option
                v-if="formData.region && item.regions.indexOf(formData.region) != -1"
                :key="i"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </template>
          </el-select>
          <el-form-item
            v-for="(value, index) in formData.scoreCalcRuleIds"
            :key="index"
            label-width="250px"
            :label="options.rules.filter(item => item._id == value)[0].name"
          >
            <el-input-number
              v-model="formData.scrWeightMap[value]"
              :controls="false"
              :min="0"
              :precision="0"
              placeholder="请输入指标权重 "
              class="input-number-ranks"
            ></el-input-number>
          </el-form-item>
        </template>
        <template slot="region">
          <el-select
            v-model="formData.region"
            @change="ranksRegionChange"
            clearable
            placeholder="请先选择行政区划"
          >
            <el-option
              v-for="(item, i) in options.regions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看排行榜" :visible.sync="rankingShow" width="800px">
      <div class="" style="width: 100%;height: 500px;display: flex;flex-direction: column;">
        <el-form ref="rankObj" :model="rankObj" label-width="80px">
          <el-form-item label="服务区域">
            <el-select v-model="rankObj.value" placeholder="可搜索服务区域" clearable>
              <el-option
                v-for="item in options.serviceTerritory"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <el-table ref="ranksTable" :data="ranks.data" empty-text="暂无数据" style="flex: 1;">
          <el-table-column label="排名" width="50px">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            label="名称"
            prop="userName"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="总分" prop="allScore"></el-table-column>
          <el-table-column label="调整分数" prop="adjust"></el-table-column>
          <template v-for="(value, key, index) in ranks.data[0]">
            <el-table-column
              v-if="key.indexOf('+') != -1"
              :key="index"
              :label="key.split('+')[0] + '得分'"
              :prop="key"
              width="150px"
            ></el-table-column>
          </template>
        </el-table>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="generateRanking">生成排行</el-button>
        <el-button @click="closeDialog">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'ScoreCalcRuleGroup',
  data() {
    window.$this = this;
    return {
      name: 'ScoreCalcRuleGroup',
      fpi: {},
      searchValue: '',
      openDetail: false,
      rankingShow: false, //查看排行榜的弹窗是否显示
      formData: {},
      extFields: [],
      options: {},
      refresh: true, //表格刷新
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      rankObj: {},
      // 标模拟多指标排行
      ranks: {
        data: []
      }
    };
  },

  async mounted() {
    this.doInit();
    this.getAllData();
    this.osg.getFields('scoreCalcRuleGroup', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    //查询表格数据
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('/biz/scoreCalcRuleGroup/query.do', params, res => {
        this.refresh = false;
        this.fpi = res;
        this.$nextTick(() => {
          this.refresh = true;
          if (this.$refs.table) {
            this.$refs.table.doLayout();
          }
          this.$forceUpdate();
        });
      });
    },
    //新增指标
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    //新增指标 保存按钮
    doSave() {
      this.$refs['scoreForm'].$refs['formData'].validate(valid => {
        const isValid = Object.values(this.formData.scrWeightMap).every(
          value => value !== undefined && value !== null
        );

        console.log(112223, valid);
        if (valid && isValid) {
          this.osg.ajax(
            '/biz/scoreCalcRuleGroup/upsert.do',
            { data: JSON.stringify(this.formData) },
            () => {
              this.osg.toast('保存成功');
              this.doInit();
              this.getData();
            }
          );
        }
      });

      // /serviceCouponDef/upsert
    },
    //新增指标 取消按钮
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {}, stcIds: [], scoreCalcRuleIds: [], scrWeightMap: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
    },
    //编辑指标
    doEdit(row) {
      this.formData = this.$util.deepCopy(row);

      this.openDetail = true;
    },
    //启用
    doEnable(id) {
      this.osg.ajax('biz/scoreCalcRuleGroup/enable.do', { id }, () => {
        this.osg.toast('启用成功');
        this.getData();
        this.getAllData();
      });
    },
    //禁用
    doDisable(id) {
      this.osg.ajax('biz/scoreCalcRuleGroup/disable.do', { id }, () => {
        this.osg.toast('禁用成功');
        this.getData();
        this.getAllData();
      });
    },
    //删除
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('biz/scoreCalcRuleGroup/delete.do', { id }, () => {
          this.osg.toast('删除成功');
          this.getData();
          this.getAllData();
        });
      });
    },
    //查询指标
    getAllData() {
      this.osg.ajax(
        'biz/scoreCalcRule/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.options.rules = res.data;
          console.log('处理指标数据', this.options.rules);
        }
      );
    },
    // 指标变更:
    indexsChange(e) {
      console.log('拿到的对象', e);
      console.log(this.formData);

      this.formData.scrWeightMap = Object.fromEntries(
        Object.entries(this.formData.scrWeightMap).filter(([key]) => e.includes(key))
      );

      console.log('this.formData.scrWeightMap', this.formData.scrWeightMap);
    },
    // 模拟多指标排行 行政区划变更
    ranksRegionChange() {
      this.formData.scoreCalcRuleIds = [];
      this.formData.scrWeightMap = {};
      console.log('122333444444', this.options.rules);
    },

    //文本处理
    getTooltipContent(row) {
      const ids = row.scoreCalcRuleIds || [];
      const rules = this.options.rules || [];
      const weightMap = row.scrWeightMap || {};

      let html = '';

      for (const item of ids) {
        const rule = rules.find(key => key._id === item);
        const name = rule ? rule.name : '未知指标';
        const weight = weightMap[item] || '';
        html += `<div>${name} 权重为：${weight}</div>`;
      }

      return html;
    },
    //查看排行榜
    viewRanking(row) {
      this.getST(row.region);

      //打开弹出窗
      this.ranks.data = [];
      this.rankingShow = true;
      this.rankObj = this.$util.deepCopy(row);

      //直接生成排行榜
      this.generateRanking();
    },
    //生成排行榜弹窗
    generateRanking() {
      console.log(11122233, this.rankObj);
      const { region, value, scoreType, scrWeightMap } = this.rankObj;
      let params = {
        region,
        stcIds: [value],
        scoreType,
        data: scrWeightMap,
        resourceType: 'technician'
      };
      //stcIds 服务区域id
      // {"region":"110000","stcIds":["6861781309352755064"],"scoreType":"new","resourceType":"technician","data":{"9151898116124197681":1}}
      this.osg.ajax('biz/scoreUser/simulateRankList.do', { data: JSON.stringify(params) }, res => {
        this.ranks.data = res.data;
      });
    },
    //关闭生成排行榜弹窗
    closeDialog() {
      this.rankingShow = false;
    },
    // 获取对应行政区域规划下的 服务区域
    getST(regex) {
      this.osg.ajax(
        'basic/serviceTerritoryCustom/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '1',
          'in:regions|array#and': regex,
          sortField: 'territoryNum,createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.serviceTerritory = res.data;
          this.$forceUpdate();
        }
      );
    }
  }
};
</script>
